import React from 'react'
import saberImg from "../../assets/Saber.jpg"
import { FaFacebook, FaGithub, FaInstagram, FaLinkedinIn } from 'react-icons/fa'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const Contact = () => {
    return (
        <HelmetProvider>
            <Helmet>
                <title>FreshCart | Contact</title>
            </Helmet>
            <section className='py-16' >
                <div className='container'>
                    <div className='text-center p-5 mb-8'>
                        <h1 className='text-3xl mb-3 font-bold text-green-500'>Contact</h1>
                        <p className='text-neutral-400'>You can contact me via links & phone number below</p>
                    </div>
                    <div className='flex'>
                        <div className='pb-10 p-5 flex flex-col border border-gray-200 rounded'>
                            <div className='about flex gap-4 mb-5 items-center'>
                                <img src={saberImg} alt={"Mohamed Saber"} width="90" className='rounded-full p-1 border-2 border-green-500' />
                                <div className='flex flex-col'>
                                    <span className='name block text-green-600 text-base capitalize font-medium'>Mohamed Saber Abd-Eltawab</span>
                                    <span className='job block text-sm text-neutral-600'>MERN Stack Developer</span>
                                </div>
                            </div>
                            <p className='text-sm text-neutral-500 mb-3 leading-6'><span className='text-black text-base font-medium font-serif'>MERN Stack</span> Developer with one year of experience developing web, and business
                                intelligence solutions using React.JS, Node.JS, Express.JS, MongoDB and SQL
                                Server. Expertise in requirements analysis, design, development, testing,
                                maintenance, enhancement, and production support of business applications.
                                Certified Web Development Professional with a deep passion for technology,
                                extensive technological expertise, and well-developed teamwork abilities
                            </p>
                            <p className='text-sm text-neutral-500 mb-3 leading-6'><span className='text-green-600'>Experience : </span> 1 Year</p>
                            <p className='text-sm text-neutral-500 mb-3 leading-6'><span className='text-green-600'>Phone : </span> 01210529969</p>
                            <p className='text-sm text-neutral-500 mb-6 leading-6'><span className='text-green-600'>E-mail : </span> mohamed.saber.abdeltawab@gmail.com</p>
                            <div className='team_social flex gap-3'>
                                <a href={"https://github.com/MohamedSaber55"} className='p-3 bg-gray-200 rounded cursor-pointer hover:bg-green-500 hover:text-white transition duration-300'><FaGithub /></a>
                                <a href={"https://www.facebook.com/profile.php?id=100014025102184"} className='p-3 bg-gray-200 rounded cursor-pointer hover:bg-green-500 hover:text-white transition duration-300'><FaFacebook /></a>
                                <a href={"https://www.instagram.com/mo_saber5/"} className='p-3 bg-gray-200 rounded cursor-pointer hover:bg-green-500 hover:text-white transition duration-300'><FaInstagram /></a>
                                <a href={"https://www.linkedin.com/in/mohamed-saber-562149218/"} className='p-3 bg-gray-200 rounded cursor-pointer hover:bg-green-500 hover:text-white transition duration-300'><FaLinkedinIn /></a>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
        </HelmetProvider>
    )
}

export default Contact